import { Button, Col, Flex, Form, Input, Row, Typography } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { PublicFormShell } from '@/features/externalForm/components/PublicFormShell';

const { Text } = Typography;

const PreviewField = ({ label, children }) => (
  <Form.Item label={label} required style={{ marginBottom: 0 }}>
    {children}
  </Form.Item>
);

const PreviewVehicleFields = () => (
  <Form layout='vertical' size='large' requiredMark style={{ pointerEvents: 'none' }}>
    <Row gutter={[16, 12]}>
      <Col span={12}>
        <PreviewField label='Placa'>
          <Flex gap={8}>
            <Input placeholder='Ingresar placa' style={{ flex: 1 }} />
            <Button type='primary' icon={<FontAwesomeIcon icon={faSearch} />}>Buscar</Button>
          </Flex>
        </PreviewField>
      </Col>
      <Col span={12}>
        <PreviewField label='Código Fasecolda'>
          <Input placeholder='Código Fasecolda' />
        </PreviewField>
      </Col>
      <Col span={12}>
        <PreviewField label='Estado del vehículo'>
          <Flex>
            <Button type='primary' style={{ flex: 1, borderRadius: '6px 0 0 6px' }}>Usado</Button>
            <Button style={{ flex: 1, borderRadius: '0 6px 6px 0' }}>Nuevo</Button>
          </Flex>
        </PreviewField>
      </Col>
      <Col span={12}>
        <PreviewField label='Categoría'>
          <Input placeholder='Categoría' />
        </PreviewField>
      </Col>
      <Col span={12}>
        <PreviewField label='Marca'>
          <Input placeholder='Seleccionar marca' />
        </PreviewField>
      </Col>
      <Col span={12}>
        <PreviewField label='Modelo'>
          <Input placeholder='Modelo' />
        </PreviewField>
      </Col>
      <Col span={12}>
        <PreviewField label='Referencia'>
          <Input placeholder='Seleccionar referencia' />
        </PreviewField>
      </Col>
      <Col span={12}>
        <PreviewField label='Clase'>
          <Input placeholder='Seleccionar clase' />
        </PreviewField>
      </Col>
      <Col span={12}>
        <PreviewField label='Ciudad de circulación'>
          <Input placeholder='Ciudad de circulación' />
        </PreviewField>
      </Col>
      <Col span={12}>
        <PreviewField label='Tipo de servicio'>
          <Input placeholder='Seleccionar tipo de servicio' />
        </PreviewField>
      </Col>
      <Col span={12}>
        <PreviewField label='Valor asegurado'>
          <Input placeholder='Ingrese valor asegurado' />
        </PreviewField>
      </Col>
      <Col span={12}>
        <PreviewField label='Valor de accesorios'>
          <Input placeholder='Ingresar valor de accesorios' />
        </PreviewField>
      </Col>
    </Row>
  </Form>
);

export const ExternalFormPreview = ({ form }) => (
  <div style={{ minWidth: 0, background: '#ffffff', border: '1px solid #e4e8f0', borderRadius: 16, overflow: 'hidden' }}>
    <Flex justify='space-between' align='center' wrap='wrap' style={{ padding: '14px 20px', borderBottom: '1px solid #e4e8f0' }}>
      <Text strong>Vista previa</Text>
      <Text type='secondary' style={{ fontSize: 12 }}>Así lo verá tu cliente</Text>
    </Flex>
    <PublicFormShell form={form} currentStep={0} embedded>
      <Flex vertical style={{ padding: 'clamp(24px, 5vw, 40px) clamp(20px, 5vw, 40px) 0' }}>
        <Text style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: form.primaryColor }}>
          Paso 1 de 3
        </Text>
        <Text strong style={{ fontSize: 24, color: form.textColor }}>Información del vehículo</Text>
      </Flex>
      <div style={{ padding: '16px clamp(20px, 5vw, 40px) 8px' }}>
        <PreviewVehicleFields />
      </div>
    </PublicFormShell>
  </div>
);
